module.exports = __webpack_public_path__ + "img/public/siteImages/onboardFooterImage.svg?dd3a1981";